<p>side-panel works!</p>
{{SelectedRoute | async | json}}